export default __webpack_public_path__ + "static/media/Hubano-4Open.3ae5749e.jpg";